import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Ordered alphabetically, "Otros" always last so users see the standard ones first
export const CATEGORIES = [
  'Arte', 'Cultura', 'Deporte', 'Educación', 'Gastronomía',
  'Música', 'Solidario', 'Stand Up', 'Tecnología', 'Turismo', 'Otros',
];

const BasicInfoSection = ({ formData, handleChange, inputCls, renderFieldError }) => (
  <>
    <div>
      <Label className="text-[#0A0A0A]">Título *</Label>
      <Input value={formData.title} onChange={(e) => handleChange('title', e.target.value)} className={inputCls('title')} data-testid="title-input" />
      {renderFieldError("title")}
    </div>

    <div>
      <Label className="text-[#0A0A0A]">Descripción corta * <span className="text-xs text-[#737373]">({formData.description_short.length}/150)</span></Label>
      <Input value={formData.description_short} onChange={(e) => handleChange('description_short', e.target.value)} maxLength={150} className={inputCls('description_short')} data-testid="short-desc-input" />
      {renderFieldError("description_short")}
    </div>

    <div>
      <Label className="text-[#0A0A0A]">Descripción completa *</Label>
      <Textarea value={formData.description_long} onChange={(e) => handleChange('description_long', e.target.value)} rows={4} className={inputCls('description_long')} data-testid="long-desc-input" />
      {renderFieldError("description_long")}
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <Label className="text-[#0A0A0A]">Categoría *</Label>
        <Select value={formData.category} onValueChange={(v) => handleChange('category', v)}>
          <SelectTrigger className={inputCls('category')} data-testid="category-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white border-[#E5E5E5]">
            {CATEGORIES.map((cat) => <SelectItem key={cat} value={cat}>{cat}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-[#0A0A0A]">Modalidad *</Label>
        <Select value={formData.modality} onValueChange={(v) => handleChange('modality', v)}>
          <SelectTrigger className={inputCls('modality')}><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white border-[#E5E5E5]">
            <SelectItem value="presencial">Presencial</SelectItem>
            <SelectItem value="virtual">Virtual</SelectItem>
            <SelectItem value="híbrido">Híbrido</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>

    {formData.category === 'Otros' && (
      <div>
        <Label className="text-[#0A0A0A]">¿Cuál? *</Label>
        <Input
          value={formData.custom_category}
          onChange={(e) => handleChange('custom_category', e.target.value)}
          placeholder="Ej: Stand Up, Feria, Charla"
          className={inputCls('custom_category')}
          data-testid="custom-category-input"
        />
        {renderFieldError("custom_category")}
      </div>
    )}

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <Label className="text-[#0A0A0A]">Fecha * <span className="text-xs text-[#737373]">(DD/MM/AAAA)</span></Label>
        <Input
          value={formData.date}
          onChange={(e) => handleChange('date', e.target.value)}
          placeholder="14/08/2026"
          inputMode="numeric"
          className={inputCls('date')}
          data-testid="date-input"
        />
        {renderFieldError("date")}
      </div>
      <div>
        <Label className="text-[#0A0A0A]">Hora * <span className="text-xs text-[#737373]">(24hs, ej: 21:00)</span></Label>
        <Input
          value={formData.time}
          onChange={(e) => handleChange('time', e.target.value)}
          placeholder="21:00"
          inputMode="numeric"
          className={inputCls('time')}
          data-testid="time-input"
        />
        {renderFieldError("time")}
      </div>
    </div>

    <div>
      <Label className="text-[#0A0A0A]">Capacidad *</Label>
      <Input type="number" min="1" value={formData.capacity} onChange={(e) => handleChange('capacity', e.target.value)} placeholder="100" className={inputCls('capacity')} data-testid="capacity-input" />
      {renderFieldError("capacity")}
    </div>
  </>
);

export default BasicInfoSection;
